module.exports = __webpack_public_path__ + "img/unity-package-manager1.95b4082c.png";